import { EXPERIMENTS } from '@src/experiments'
import useExperimentBucket from '@src/quince-site-common/src/hooks/useExperimentBucket'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

export function useShowBuyNowBasedOnDeviceType(isMobile: boolean) {
  const experimentBucketName = useExperimentBucket(EXPERIMENTS.SHOW_ATC_ON_MOBILE.experimentName)

  if (!isMobile) return true
  if (!isBrowser()) return false
  return experimentBucketName === EXPERIMENTS.SHOW_ATC_ON_MOBILE.bucketNames.show
}
